<template>
  <div class="home">
    <div class="wrapper">
      <nav
        id="sidebar"
        class="sidebar js-sidebar"
        v-bind:class="{ collapsed: collapsed }"
      >
        <div class="sidebar-content js-simplebar">
          <router-link to="/" class="sidebar-brand">
            <span class="align-middle">
              <img src="assets/img/logo-sm.png" />
            </span>
          </router-link>

          <ul class="sidebar-nav sidebar_fnd">
            <!-- General -->
            <li
              class="sidebar-item"
              v-bind:class="{ active: nombre_ruta == 'Dashboard' }"
            >
              <router-link to="/" class="sidebar-link">
                <i class="align-middle bx bxs-dashboard bx-sm"></i>
                <span class="align-middle">Inicio</span>
              </router-link>
            </li>
            
            <li
              v-if="session.usuario.perfil == 0 || session.usuario.perfil == 1 || session.usuario.perfil == 4 || session.usuario.perfil == 3"
              class="sidebar-item"
              v-bind:class="{ active: nombre_ruta == 'Aliados' }"
            >
              <router-link to="/aliados" class="sidebar-link">
                <i class="align-middle bx bx-store bx-sm"></i>
                <span class="align-middle">Aliados</span>
              </router-link>
            </li>

            <li
              v-if="session.usuario.perfil == 0 || session.usuario.perfil == 2"
              class="sidebar-item"
              v-bind:class="{ active: nombre_ruta == 'Marketing' }"
            >
              <router-link to="/marketing" class="sidebar-link">
                <i class="align-middle bx bxs-component bx-sm"></i>
                <span class="align-middle">Marketing</span>
              </router-link>
            </li>

            <li
              v-if="session.usuario.perfil == 0"
              class="sidebar-item"
              v-bind:class="{ active: nombre_ruta == 'Agentes' }"
            >
              <router-link to="/agentes" class="sidebar-link">
                <i class="align-middle bx bx-user-voice bx-sm"></i>
                <span class="align-middle">Agentes</span>
              </router-link>
            </li>

            <!-- Membresias -->
            <li class="sidebar-header">Membresías</li>
            <li
              v-if="session.usuario.perfil == 0 || session.usuario.perfil == 1"
              class="sidebar-item"
              v-bind:class="{ active: nombre_ruta == 'Usuarios' }"
            >
              <router-link to="/panel_usuarios" class="sidebar-link">
                <i class="align-middle bx bx-credit-card-front bx-sm"></i>
                <span class="align-middle">Usuarios</span>
              </router-link>
            </li>
            <li
              v-if="session.usuario.perfil == 0"
              class="sidebar-item"
              v-bind:class="{ active: nombre_ruta == 'Codigos_influencers' }"
            >
              <router-link to="/codigos_influencers/1" class="sidebar-link">
                <i class="align-middle bx bx-list-ul bx-sm"></i>
                <span class="align-middle">Códigos influencers</span>
              </router-link>
            </li>
            <!-- Administracion contenido web -->
            <!-- <li class="sidebar-header">Contenido Web</li>
            <li
              v-if="session.usuario.perfil == 0 "
              class="sidebar-item"
              v-bind:class="{ active: nombre_ruta == 'Usuarios' }"
            >
              <router-link to="#" class="sidebar-link">
                <i class="align-middle bx bx-gift bx-sm"></i>
                <span class="align-middle">Beneficios</span>
              </router-link>
            </li>
            <li
              v-if="session.usuario.perfil == 0"
              class="sidebar-item"
              v-bind:class="{ active: nombre_ruta == 'Usuarios' }"
            >
              <router-link to="#" class="sidebar-link">
                <i class="align-middle bx bx-notepad bx-sm"></i>
                <span class="align-middle">Paginas</span>
              </router-link>
            </li> -->
          </ul>
        </div>
      </nav>

      <div class="main">
        <nav class="navbar navbar-expand navbar-light navbar-bg">
          <a
            v-on:click="collapsed = !collapsed"
            class="sidebar-toggle js-sidebar-toggle"
            style="color: #fff"
          >
            <i class="hamburger align-self-center" style="color: #fff"></i>
          </a>

          <div class="navbar-collapse collapse">
            <ul class="navbar-nav navbar-align">
              <li class="nav-item dropdown">
                <a
                  class="nav-icon dropdown-toggle"
                  href="#"
                  id="alertsDropdown"
                  data-bs-toggle="dropdown"
                >
                  <div class="position-relative">
                    <i class="bx bx-bell"></i>
                    <!-- <span class="indicator">4</span> -->
                  </div>
                </a>
                <div
                  class="dropdown-menu dropdown-menu-lg dropdown-menu-end py-0"
                  aria-labelledby="alertsDropdown"
                >
                  <div class="dropdown-menu-header">Notificaciones</div>
                  <div class="list-group"></div>
                  <div class="dropdown-menu-footer">
                    <a href="#" class="text-muted">Ver todas</a>
                  </div>
                </div>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-icon dropdown-toggle"
                  href="#"
                  id="messagesDropdown"
                  data-bs-toggle="dropdown"
                >
                  <div class="position-relative">
                    <i class="bx bx-message-dots"></i>
                  </div>
                </a>
                <div
                  class="dropdown-menu dropdown-menu-lg dropdown-menu-end py-0"
                  aria-labelledby="messagesDropdown"
                >
                  <div class="dropdown-menu-header">
                    <div class="position-relative">Mensajes</div>
                  </div>
                  <div class="list-group"></div>
                  <div class="dropdown-menu-footer">
                    <a href="#" class="text-muted">Ver todos</a>
                  </div>
                </div>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-icon dropdown-toggle d-inline-block d-sm-none"
                  href="#"
                  data-bs-toggle="dropdown"
                >
                  <i class="align-middle" data-feather="settings"></i>
                </a>

                <a
                  class="nav-link dropdown-toggle d-none d-sm-inline-block"
                  href="#"
                  data-bs-toggle="dropdown"
                >
                  <img
                    src="assets/img/user.png"
                    class="avatar img-fluid rounded me-1"
                  />
                  <span>{{ usuario.nombres }}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-end">
                  <!--  <router-link to="/perfil" class="dropdown-item">
                    <i class="bx bx-user"></i>
                    Perfil</router-link
                  > -->

                  <a v-on:click="set_logout" class="dropdown-item" href="#">
                    <i class="bx bx-log-out-circle"></i>
                    Salir</a
                  >
                </div>
              </li>
            </ul>
          </div>
        </nav>

        <main class="content content_fnd">
          <div class="container-fluid p-0">
            <router-view :session="session" />
          </div>
        </main>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Home",
  data() {
    return {
      loading: true,
      session: null,
      usuario: null,
      nombre_ruta: null,
      collapsed: false,
    };
  },
  created: function () {
    var session = localStorage.getItem("sess_reddy_back");
    if (session == undefined) {
      this.$router.push("/auth");
    } else {
      session = JSON.parse(session);
      this.session = session;
      this.usuario = session.usuario;
      this.loading = false;
      this.nombre_ruta = this.$route.name;
    }
  },
  methods: {
    set_logout: function () {
      localStorage.removeItem("sess_reddy_back");
      location.reload();
    },
  },
  watch: {
    $route() {
      this.nombre_ruta = this.$route.name;
    },
  },
};
</script>
